module.exports = __webpack_public_path__ + "static/media/GSlogo.43e74a5d.JPG";